<template>
    <a class="cover" :href="link" target="_blank">
        <img :src="imgsrc"/>
        <h3 class="title" :style="{ fontSize }">{{ title }}</h3>
    </a>
</template>

<script>
export default {
    props: [ 'link', 'image', 'title' ],
    computed: {
        imgsrc() {
            if (this.image) return this.image;
            return this.link + (this.link.slice(-1) == "/" ? "" : "/") + "project/images/bg.jpg";
        },
        fontSize() {
            if (this.title.length > 12) return '18px';
            if (this.title.length > 6) return '26px';
            else return '30px'
        }
    }
}
</script>

<style lang="less" scoped>
.cover {
    position: relative;
    img {
        width: 266px;
        height: 150px;
        object-fit: cover;
    }
}
.title {
    position: absolute;
    left: 5px;
    top: -60px;
    text-align: center;
    min-width: 200px;
    color: #FFFFFF;
    font-weight: 600;
    text-shadow: 1.5px 1.5px 1.5px #000;
    overflow: hidden;
}
</style>